export interface Datum {
  [key: string]: string | undefined;
}

export interface ParseResult {
  header?: string[] | null;
  data: Datum[];
}

const objPattern = new RegExp(
  (
    // Delimiters.
    "(\\,|\\r?\\n|\\r|^)" +

    // Quoted fields.
    "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

    // Standard fields.
    "([^\"\\,\\r\\n]*))"
  ),
  "gi"
);

export const parse = (content: string | null) => {
  const result: ParseResult = {
    header: null,
    data: []
  };

  if (!content) {
    return result;
  }

  const arrData: [string[]] = [[]];
  let matched = null;
  while(matched = objPattern.exec(content.trim())) {
    const matchedDelimiter = matched[1];
    if(matchedDelimiter.length && matchedDelimiter !== ",") {
      arrData.push([]);
    }
    if(matched[2]) {
      // quoted value
      const matchedValue = matched[2].trim().replace(/"/g, "");
      arrData[arrData.length - 1].push(matchedValue);
    } else {
      arrData[arrData.length - 1].push(matched[3] ? matched[3].trim() : matched[3]);
    }
  }

  result.header = arrData.shift();
  // remap the data to JSON objects
  result.data = arrData.map(rowData => {
    const entry: Datum = {};
    result.header?.forEach((attribute, index) => {
      entry[attribute] = rowData[index];
    });
    return entry;
  });
  return result;
};
